import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import dashboardService from "services/DashBoardService";
import profileManagerService from "services/ProfileManagerService";
import transportService from "services/transportService";

export const useDocumentType = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    ["dashboard-document-types"],
    () => dashboardService.getDonutChart(),
    {
      enabled: true,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.fetch_type_docs", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return { data };
      },
    }
  );
};

export const useTotalDocument = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    ["dashboard-total-documents"],
    () => dashboardService.getTotalDocs(),
    {
      enabled: true,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.fetch_total_docs", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: { total: {} } }),
      select: response => {
        const { data } = response;
        return { data: data.total };
      },
    }
  );
};

export const useTotalNotify = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    ["dashboard-total-notify"],
    () => dashboardService.getTotalNotify(),
    {
      enabled: true,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.fetch_total_notify", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return { data };
      },
    }
  );
};

export const useStackData = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    ["dashboard-documents-expired"],
    () => dashboardService.getStackedData(),
    {
      enabled: true,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.fetch_docs_expired", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: {} }),
      select: response => {
        const { data } = response;
        return { data };
      },
    }
  );
};

export const useMyProfile = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(["my-profile"], () => profileManagerService.getMyProfile(), {
    enabled: true,
    retry: 1,
    refetchOnWindowFocus: false,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
          t("message.fetch_profile", {
            status: t("message.error"),
          }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
    initialData: Object({ data: {} }),
    select: response => {
      return { data: response };
    },
  });
};

export const useProfile = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(["profile"], () => profileManagerService.getProfile(), {
    enabled: true,
    retry: 1,
    refetchOnWindowFocus: false,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      // addToast(
      //   formConvertErrorMessage(
      //     errorResponse.message ||
      //       t("message.fetch_profile", {
      //         status: t("message.error"),
      //       }),
      //     t
      //   ),
      //   {
      //     appearance: "error",
      //     autoDismiss: true,
      //   }
      // );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
    initialData: Object({ data: {} }),
    select: response => {
      const { data } = response;
      return { data };
    },
  });
};

export const useAvatar = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    "avatar",
    () => profileManagerService.getAvatar(payload.avatarId),
    {
      retry: 2,
      enabled: false,
      onSuccess: response => {
        const avatarImg = URL.createObjectURL(response.data);
        onSuccess(avatarImg);
      },
      onError: error => {
        const errorResponse = errorMessage(error);
        // addToast(
        //   formConvertErrorMessage(
        //     errorResponse.message ||
        //       t("message.fetch_avatar", {
        //         status: t("message.error"),
        //       }),
        //     t
        //   ),
        //   {
        //     appearance: "error",
        //     autoDismiss: true,
        //   }
        // );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
    }
  );
};

export const useUploadAvatar = (onSuccess, onError) => {
  const { t, i18n } = useTranslation("common");
  const { addToast } = useToasts();

  return useMutation(profileManagerService.uploadAvatar, {
    retry: 2,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message || t("profile.choseAvatarFail"),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useUpdateProfile = (onSuccess, onError) => {
  const { t, i18n } = useTranslation("common");
  const { addToast } = useToasts();

  return useMutation(profileManagerService.updateProfile, {
    retry: 2,
    onSuccess: response => {
      addToast(t("profile.updateProfileSuccess"), {
        appearance: "success",
        autoDismiss: true,
      });
      onSuccess(response.data);
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message || t("profile.updateProfileFail"),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

export const useDashboardTimelineStats = ({ mode, queryParams, enabled }) => {
  return useQuery(
    ["dashboard-timeline-stats", mode, queryParams],
    () =>
      mode === "dvvc"
        ? dashboardService.statsByDvvc(queryParams)
        : dashboardService.statsByStatus(queryParams),
    {
      enabled: Boolean(
        enabled &&
        queryParams &&
        queryParams.from_time &&
        queryParams.to_time &&
        queryParams.status
      ),
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
};

// Stats By Shipping Type
export const useStatsByShippingType = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  return useQuery(
    ["stats-by-shipping-type"],
    () => dashboardService.statsByShippingType(payload),
    {
      retry: 1,
      enabled: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.fetch_stats_order", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

// List Order Dashboard
export const useListOrderDashboard = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["dashboard"]);
  const { addToast } = useToasts();

  const { params } = payload;
  let queryKey = params?.page || "all";
  if (params?.type) {
    switch (params.type) {
      case "list":
        queryKey = params?.page || "all";
        break;
      case "search_order_code":
        queryKey = "search-order-code";
        break;
      default:
        break;
    }
  }

  return useQuery(
    ["dashboard-orders", queryKey],
    () => dashboardService.listOrderDashboard(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);

        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
            t("message.list_order", {
              status: t("message.error"),
            }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );

        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

export const useListTransportDashboard = ({
  payload,
  onSuccess = undefined,
  onError = undefined,
}) => {
  return useQuery(
    ["transport-list-dashboard"],
    () => transportService.getTransports(payload),
    {
      enabled: false,
      retry: 1,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: [] }),
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

export const useTransportOrderStatus = ({
  payload,
  onSuccess = undefined,
  onError = undefined,
}) => {
  return useQuery(
    ["transport-order-status"],
    () => transportService.transportOrderStatus(payload),
    {
      enabled: false,
      retry: 0,
      refetchOnWindowFocus: false,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      initialData: Object({ data: [] }),
      select: response => {
        return response?.data || [];
      },
    }
  );
};
